module.exports = __webpack_public_path__ + "img/toothpaste-productpackaging.5deaef9c.png";